<nav
  class="fixed top-0 left-0 h-full w-[var(--nav-width)] z-40 bg-whiteshade dark:bg-black-dark border-borders-light dark:border-borders-darker border-r"
>
  <a class="logo" routerLink="/">
    <span
      class="block my-5 ml-3 w-[170px] h-[35px] bg-black dark:bg-white mask-[url(/assets/images/icons/gemster-logo-typo.svg)] mask-size-[170px_35px]"
    ></span>
  </a>

  <button
    routerLink="/compass"
    class="btn h-[56px]! flex! gap-1 px-2! ml-1.5 text-[16px]! rounded-full!"
  >
    <img
      src="/assets/images/icons/gem.svg"
      alt=""
      class="relative -top-[2px] w-[34px] h-[34px]"
    />
    <span>{{ "FIND_A_GEM" | translate }}</span>
  </button>

  <ul class="menu pt-4">
    @for (item of primaryNavigationItems; track item.route) {
    <li routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
      <a [routerLink]="item.route">
        <span [class]="item.iconClasses"></span>
        {{ item.labelKey | translate }}
      </a>
    </li>
    }

    <div class="border-t border-borders-light dark:border-borders-darker"></div>

    @for (item of secondaryNavigationItems; track item.route) {
    <li
      class="mb-0"
      [routerLinkActive]="item.route !== '/collections' ? 'active' : ''"
      [ngClass]="{active: item.route === '/collections' && isListsRoute}"
    >
      <a [routerLink]="item.route">
        <span [class]="item.iconClasses"></span>
        {{ item.labelKey | translate }}
      </a>
    </li>
    }
  </ul>

  <div class="absolute pl-3 bottom-1 [@media(min-height:768px)]:bottom-5">
    <a
      routerLink="/about"
      class="block text-grey dark:text-lightGrey mb-1 [@media(min-height:768px)]:mb-2 text-sm"
      >{{ "ABOUT_GEMSTER" | translate }}</a
    >
    <span class="text-grey dark:text-lightGrey text-sm"
      >© {{ currentYear }}</span
    >
  </div>
</nav>

<ng-container
  class="mask-[url(/assets/images/icons/home.svg)] mask-[url(/assets/images/icons/works.svg)] mask-[url(/assets/images/icons/calendar.svg)] mask-[url(/assets/images/icons/star.svg)] mask-[url(/assets/images/icons/lists.svg)] mask-[url(/assets/images/icons/collaborators.svg)] mask-[url(/assets/images/icons/stats.svg)]"
></ng-container>
